import { Heading } from '@chakra-ui/react';
import React from 'react';

import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { VehicleType } from '@/types/used-cars/used-cars.types';

import styles from './heading-section.module.scss';

export const HeadingSection: React.FC<{
  headingContentText: string;
  headingContentTextDemo: string;
  carType: VehicleType;
}> = ({
  headingContentText,
  headingContentTextDemo,
  carType = VehicleType.Used,
}) => {
  const { activeCarType } = useFiltersQuery();
  const actualActiveCarType = activeCarType ? activeCarType : carType;

  return (
    <div className={styles.wrapper}>
      <Heading className={styles.heading}>
        {headingContentText != '' ? headingContentText : 'Search all Used Cars'}
      </Heading>
      {actualActiveCarType == VehicleType.Demo ? (
        <div className={styles.demoContent}>
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: headingContentTextDemo }}
          />
        </div>
      ) : (
        <div
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: headingContentTextDemo }}
        ></div>
      )}
    </div>
  );
};
